// before 20-5-2026

// import React, { useEffect, useState } from 'react';
// import { Container } from 'react-bootstrap';
// import { GetAllLeadsSearchAction } from '../../Redux/Actions/UsersAction';
// import { useDispatch, useSelector } from 'react-redux';
// import { Line, Pie, Bar } from 'react-chartjs-2';
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   BarElement,
// } from 'chart.js';

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement,
//   BarElement,
// );

// export const SalesChats = ({ salesdata }) => {
//   const dispatch = useDispatch();
//   const [isLoading, setIsLoading] = useState(true);
//   const users = useSelector((state) => state.Allusers.Get_users);
//   const usersarray = Array.isArray(users?.data) ? users.data : [];

//   // جلب بيانات الـ Leads
//   const getallleadsbysales = async () => {
//     setIsLoading(true);
//     await dispatch(GetAllLeadsSearchAction(`sales=${salesdata._id}`));
//     setIsLoading(false);
//   };

//   useEffect(() => {
//     getallleadsbysales();
//   }, []);

//   // تصفية الـ Leads الخاصة بالـ Sales الحالي
//   const filteredLeads = usersarray.filter((lead) => lead.sales?._id === salesdata._id);

//   // دالة لحساب عدد الـ Leads لكل حالة
//   const countLeadsByStage = (stageName) => {
//     return filteredLeads.filter((lead) => lead.stage?.name === stageName).length;
//   };

//   // حساب عدد الـ Leads لكل حالة
//   const leadsCount = {
//     fresh: countLeadsByStage('Fresh'),
//     doneDeal: countLeadsByStage('Done Deal'),
//     followUp: countLeadsByStage('Follow Up'),
//     interested: countLeadsByStage('Interested'),
//     notInterested: countLeadsByStage('Not Interested'),
//     followingAfterMeeting: countLeadsByStage('Following After Meeting'),
//     meeting: countLeadsByStage('Meeting'),
//     cancelMeeting: countLeadsByStage('Cancel Meeting'),
//     longFollow: countLeadsByStage('Long Follow'),
//   };

//   // إعداد بيانات الرسم البياني العمودي
//   const barChartData = {
//     labels: [
//       'Fresh',
//       'Done Deal',
//       'Follow Up',
//       'Interested',
//       'Not Interested',
//       'Following After Meeting',
//       'Meeting',
//       'Cancel Meeting',
//       'Long Follow',
//     ],
//     datasets: [
//       {
//         label: 'عدد الـ Leads',
//         data: [
//           leadsCount.fresh,
//           leadsCount.doneDeal,
//           leadsCount.followUp,
//           leadsCount.interested,
//           leadsCount.notInterested,
//           leadsCount.followingAfterMeeting,
//           leadsCount.meeting,
//           leadsCount.cancelMeeting,
//           leadsCount.longFollow,
//         ],
//         backgroundColor: [
//           'rgba(255, 99, 132, 0.7)',
//           'rgba(75, 192, 192, 0.7)',
//           'rgba(255, 159, 64, 0.7)',
//           'rgba(54, 162, 235, 0.7)',
//           'rgba(153, 102, 255, 0.7)',
//           'rgba(255, 205, 86, 0.7)',
//           'rgba(0, 255, 0, 0.7)',
//           'rgba(255, 0, 0, 0.7)',
//           'rgba(201, 203, 207, 0.7)',
//         ],
//         borderColor: [
//           'rgb(255, 99, 132)',
//           'rgb(75, 192, 192)',
//           'rgb(255, 159, 64)',
//           'rgb(54, 162, 235)',
//           'rgb(153, 102, 255)',
//           'rgb(255, 205, 86)',
//           'rgb(0, 255, 0)',
//           'rgb(255, 0, 0)',
//           'rgb(201, 203, 207)',
//         ],
//         borderWidth: 1,
//       },
//     ],
//   };

//   // خيارات الرسم البياني
//   const barChartOptions = {
//     responsive: true,
//     plugins: {
//       legend: {
//         display: false,
//       },
//       title: {
//         display: true,
//         text: `توزيع حالات الـ Leads لـ ${salesdata.name}`,
//         font: {
//           size: 16,
//         },
//       },
//       tooltip: {
//         callbacks: {
//           label: function (context) {
//             return `${context.parsed.y} Leads`;
//           },
//         },
//       },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         title: {
//           display: true,
//           text: 'عدد الـ Leads',
//         },
//         ticks: {
//           stepSize: 1,
//         },
//       },
//       x: {
//         title: {
//           display: true,
//           text: 'حالة الـ Lead',
//         },
//       },
//     },
//   };

//   return (
//     <Container>
//       <div className="notification mx-2">
//         <div className="notiglow"></div>
//         <div className="notiborderglow"></div>
//         <div className="notititle">Name : {salesdata.name}</div>

//         {isLoading ? (
//           <div className="notibody">جاري تحميل البيانات...</div>
//         ) : (
//           <>
//             <div className="notibody">
//               <div style={{ marginBottom: '20px' }}>
//                 <span style={{ color: 'royalblue', fontWeight: 'bold' }}>إجمالي الـ Leads: </span>
//                 <span style={{ fontWeight: 'bold' }}>{filteredLeads.length}</span>
//               </div>

//               {/* الرسم البياني العمودي */}
//               <div
//                 style={{
//                   background: '#fff',
//                   padding: '20px',
//                   borderRadius: '10px',
//                   boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//                   marginBottom: '20px',
//                 }}
//               >
//                 <div style={{ height: '500px' }}>
//                   <Bar data={barChartData} options={barChartOptions} />
//                 </div>
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//     </Container>
//   );
// };



import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { GetAllLeadsSearchAction } from '../../Redux/Actions/UsersAction';
import { useDispatch, useSelector } from 'react-redux';
import { Line, Pie, Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  BarElement,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  BarElement,
);

export const SalesChats = ({ salesdata }) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const users = useSelector((state) => state.Allusers.Get_users);
  const usersarray = Array.isArray(users?.data) ? users.data : [];

  // جلب بيانات الـ Leads
  const getallleadsbysales = async () => {
    setIsLoading(true);
    await dispatch(GetAllLeadsSearchAction(`sales=${salesdata._id}`));
    setIsLoading(false);
  };

  useEffect(() => {
    getallleadsbysales();
  }, []);

  // تصفية الـ Leads الخاصة بالـ Sales الحالي
  const filteredLeads = usersarray.filter((lead) => lead.sales?._id === salesdata._id);

  // دالة لحساب عدد الـ Leads لكل حالة
  const countLeadsByStage = (stageName) => {
    return filteredLeads.filter((lead) => lead.stage?.name === stageName).length;
  };

  // حساب عدد الـ Leads لكل حالة
  const leadsCount = {
    fresh: countLeadsByStage('Fresh'),
    doneDeal: countLeadsByStage('Done Deal'),
    followUp: countLeadsByStage('Follow Up'),
    interested: countLeadsByStage('Interested'),
    notInterested: countLeadsByStage('Not Interested'),
    followingAfterMeeting: countLeadsByStage('Following After Meeting'),
    meeting: countLeadsByStage('Meeting'),
    cancelMeeting: countLeadsByStage('Cancel Meeting'),
    longFollow: countLeadsByStage('Long Follow'),
  };

  // إعداد بيانات الرسم البياني العمودي
  const barChartData = {
    labels: [
      'Fresh',
      'Done Deal',
      'Follow Up',
      'Interested',
      'Not Interested',
      'Following After Meeting',
      'Meeting',
      'Cancel Meeting',
      'Long Follow',
    ],
    datasets: [
      {
        label: 'عدد الـ Leads',
        data: [
          leadsCount.fresh,
          leadsCount.doneDeal,
          leadsCount.followUp,
          leadsCount.interested,
          leadsCount.notInterested,
          leadsCount.followingAfterMeeting,
          leadsCount.meeting,
          leadsCount.cancelMeeting,
          leadsCount.longFollow,
        ],
        backgroundColor: [
          'rgba(255, 99, 132, 0.7)',
          'rgba(75, 192, 192, 0.7)',
          'rgba(255, 159, 64, 0.7)',
          'rgba(54, 162, 235, 0.7)',
          'rgba(153, 102, 255, 0.7)',
          'rgba(255, 205, 86, 0.7)',
          'rgba(0, 255, 0, 0.7)',
          'rgba(255, 0, 0, 0.7)',
          'rgba(201, 203, 207, 0.7)',
        ],
        borderColor: [
          'rgb(255, 99, 132)',
          'rgb(75, 192, 192)',
          'rgb(255, 159, 64)',
          'rgb(54, 162, 235)',
          'rgb(153, 102, 255)',
          'rgb(255, 205, 86)',
          'rgb(0, 255, 0)',
          'rgb(255, 0, 0)',
          'rgb(201, 203, 207)',
        ],
        borderWidth: 1,
      },
    ],
  };

  // خيارات الرسم البياني
  const barChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: `توزيع حالات الـ Leads لـ ${salesdata.name}`,
        font: {
          size: 16,
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `${context.parsed.y} Leads`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'عدد الـ Leads',
        },
        ticks: {
          stepSize: 1,
        },
      },
      x: {
        title: {
          display: true,
          text: 'حالة الـ Lead',
        },
      },
    },
  };

  return (
    <Container>
      <div className="notification mx-2">
        <div className="notiglow"></div>
        <div className="notiborderglow"></div>
        <div className="notititle">Name : {salesdata.name}</div>

        {isLoading ? (
          <div className="notibody">جاري تحميل البيانات...</div>
        ) : (
          <>
            <div className="notibody">
              <div style={{ marginBottom: '20px' }}>
                <span style={{ color: 'royalblue', fontWeight: 'bold' }}>إجمالي الـ Leads: </span>
                <span style={{ fontWeight: 'bold' }}>{filteredLeads.length}</span>
              </div>

              {/* الرسم البياني العمودي */}
              <div
                style={{
                  background: '#fff',
                  padding: '20px',
                  borderRadius: '10px',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                  marginBottom: '20px',
                }}
              >
                <div style={{ height: '500px' }}>
                  <Bar data={barChartData} options={barChartOptions} />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </Container>
  );
};
